import type { Lang } from "../i18n/I18nProvider";

const RELATIVE_UNITS: readonly [Intl.RelativeTimeFormatUnit, number][] = [
  ["day", 86_400_000],
  ["hour", 3_600_000],
  ["minute", 60_000],
];

/** Intl locale tag for the UI language. */
export function intlLocale(lang: Lang): string {
  return lang === "sr" ? "sr-Latn" : "en";
}

/** "2 hours ago" for an ISO time, in the UI language. Under a minute reads as "now". */
export function formatRelativeTime(iso: string, now: Date, lang: Lang): string {
  const diff = Date.parse(iso) - now.getTime();
  const format = new Intl.RelativeTimeFormat(intlLocale(lang), { numeric: "auto" });
  for (const [unit, ms] of RELATIVE_UNITS) {
    if (Math.abs(diff) >= ms) return format.format(Math.round(diff / ms), unit);
  }
  return format.format(0, "second");
}

/** Short date and time for a stored ISO timestamp. */
export function formatDateTime(iso: string, lang: Lang): string {
  return new Date(iso).toLocaleString(intlLocale(lang), {
    dateStyle: "medium",
    timeStyle: "short",
  });
}
